// src/admin/components/task/TaskPathSection.jsx
import React from 'react';
import { format, parseISO } from 'date-fns';

function formatTimestamp(value) {
  if (!value) return '—';
  try {
    return format(parseISO(value), 'MMM d, yyyy h:mm a');
  } catch {
    return value;
  }
}

export default function TaskPathSection({ meta }) {
  if (!meta) return null;

  const transitions = meta.transitions || [];
  const transitionsDropped = meta.transitions_dropped || 0;
  const visits = meta.visits || {};
  const visitStepIds = Object.keys(visits);

  if (transitions.length === 0 && visitStepIds.length === 0) {
    return null;
  }

  return (
    <div className="border rounded p-4 mb-4">
      <h6 className="fw-semibold mb-3">Path taken</h6>

      {transitions.length > 0 && (
        <div className="mb-4">
          <div className="text-muted small mb-2">Transitions</div>
          {transitionsDropped > 0 && (
            <div className="text-muted small fst-italic mb-2">
              Earliest {transitionsDropped.toLocaleString()}{' '}
              {transitionsDropped === 1 ? 'transition was' : 'transitions were'} dropped to
              keep the record within its storage budget; the path below starts partway
              through.
            </div>
          )}
          <ol className="mb-0 ps-3">
            {transitions.map((transition, index) => (
              <li key={`${transition.from}-${transition.to}-${transition.at}-${index}`} className="mb-2">
                <span className="fw-semibold">{transition.from}</span>
                {' → '}
                <span className="fw-semibold">{transition.to}</span>
                {transition.action_text ? (
                  <span className="text-muted"> ({transition.action_text})</span>
                ) : null}
                <div className="text-muted small">{formatTimestamp(transition.at)}</div>
              </li>
            ))}
          </ol>
        </div>
      )}

      {visitStepIds.length > 0 && (
        <div>
          <div className="text-muted small mb-2">Step visits</div>
          <div className="row">
            {visitStepIds.map((stepId) => {
              const visit = visits[stepId] || {};
              return (
                <div className="col-md-6 mb-3" key={stepId}>
                  <div className="fw-semibold">{stepId}</div>
                  <div className="text-muted small">
                    First: {formatTimestamp(visit.first_visited_at)}
                  </div>
                  <div className="text-muted small">
                    Last: {formatTimestamp(visit.last_visited_at)}
                  </div>
                  <div className="text-muted small">
                    Visits: {visit.visit_count ?? 1}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
